import { api_GET, api_POST, api_PUT } from './_api';

const downloadAplicativos_api = {
    GetLink: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DownloadAplicativos/GetLink`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
}

export default downloadAplicativos_api;